export default function formatForInput(type, value) {
  try {
    switch (type) {
      case "True/False":
        return value;
      case "Date":
        return !!value ? value.split("T")[0] : "";
      case "Location":
        if (typeof value === "string") {
          value = value.replace(/"/g, "").replace("}", "");
          let [lat, lng] = value.split(",");
          const loc = { lat: lat.split(":")[1], lng: lng.split(":")[1]};
          return loc;
        }
        else return value;
      default:
        return value
    }
  }
  catch (err) {
    return value;
  }
}